import React from "react";
import { FormControl, ControlLabel } from "react-bootstrap";
import ajax from "../../lib/ajax.js";
import context from "../../lib/context.js";
import ReactDOM from 'react-dom';

export default class CodeList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            codeList: []
        };

        this.loadCodeList = this.loadCodeList.bind(this);
        this.onChange = this.onChange.bind(this);
    }    

    componentDidMount() {
        this.loadCodeList();
    }

    componentWillReceiveProps(a, b) {
        if (this.props.onAfterChange) {
            this.props.onAfterChange();
        }
    }

    loadCodeList() {
        let self = this;
        ajax.api().get(`get-codelist-by-category/${this.props.category}`)
            .then(function (res) {
                var useCode = false;
                
                if (self.props.useCode !== undefined)
                    useCode = this.props.useCode;

                if (useCode) 
                    res.data = res.data.sort(function(obj1, obj2) { 
                        if (obj1.code < obj2.code) return -1;
                        if (obj1.code > obj2.code) return 1;
                        return 0;
                    })
                else
                    res.data = res.data.sort(function(obj1, obj2) { 
                        if (obj1.codeName < obj2.codeName) return -1;
                        if (obj1.codeName > obj2.codeName) return 1;
                        return 0;
                    })

                if (self.props.onLoaded && (self.props.value || '') != '') {
                    var selectedCode = res.data.filter(x => x.code == self.props.value);
                    
                    if (selectedCode.length > 0)
                        self.props.onLoaded(selectedCode[0]);
                }

                self.setState({ codeList: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onChange(event) {
        var codeName = '';
        var propertyValue = '';
        var code = this.state.codeList.filter(x => x.code == event.target.value);

        if (code.length > 0) {
            codeName = code[0].codeName;
            propertyValue = code[0].propertyValue;
        }

        if (this.props.onChange)
            this.props.onChange(event.target.value, codeName, this.props.id, propertyValue, true);
    }

    render() {
        var codes = [];
        var allText = 'All';
        var useCode = false;
        var readOnly = false;
        var hasDefault = false;
        var showDescriptionAsLink = false

        if (this.props.readOnly !== undefined)
            readOnly = this.props.readOnly;

        if (this.props.allText !== undefined)
            allText = this.props.allText;

        if (this.props.useCode !== undefined)
            useCode = this.props.useCode;

        if (this.props.hasDefault !== undefined)
            hasDefault = this.props.hasDefault;

        if (this.props.showDescriptionAsLink !== undefined)
            showDescriptionAsLink = this.props.showDescriptionAsLink;

        codes.push(<option key="All" value="" selected="true">{allText}</option>);

        if (hasDefault == true) 
            codes.push(<option key="default" value="default">Default</option>);
        
        const self = this;
        var description = '';

        this.state.codeList.map(function (item, i) {
            codes.push(<option key={item.code} value={item.code}>{useCode == true ? item.code : item.codeName}</option>)

            if (item.code == self.props.value && showDescriptionAsLink == true && item.propertyType == 'WEBSITE') 
                description = useCode == true ? <a href={item.propertyValue} target="_blank">{item.code}</a> : <a href={item.propertyValue} target="_blank">{item.codeName}</a>;
            else if (item.code == self.props.value)
                description = useCode == true ? item.code : item.codeName;
        }, this);

        return (   
            <div className="ap-report-control-dropdown">     
            {
                readOnly == false ?
                    <FormControl
                        id={this.props.id + '-select'}
                        componentClass="select"
                        value={this.props.value}
                        onChange={this.onChange}
                        className={this.props.className}
                        readOnly={this.props.readOnly}>
                        {codes}
                    </FormControl> :
                    <div><ControlLabel className="ap-report-control-label ap-black-color">{description}</ControlLabel></div>
            }  
            </div>
        );
    }
}